import { render, staticRenderFns } from "./CelestialNavigationTab.vue?vue&type=template&id=8ce190f0&scoped=true&"
import script from "./CelestialNavigationTab.vue?vue&type=script&lang=js&"
export * from "./CelestialNavigationTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ce190f0",
  null
  
)

export default component.exports